import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import formatHTML from './formatHTML';
import { renderToStaticMarkup } from 'react-dom/server';

// const GTranslateWidget = () => {
//    const [firstState,setFirstState]=useState(true)
//   useEffect(() => {
//     // if(firstState){
//  // This will load the GTranslate script after the component has mounted
//  const script = document.createElement('script');
//  script.src = 'https://cdn.gtranslate.net/widgets/latest/popup.js';
//  script.defer = true;
//  document.body.appendChild(script);
//  setFirstState(false)
//  return () => {
//    // Cleanup the script when the component unmounts
//    document.body.removeChild(script);
//  };
//     // }
//   }, []);

//   return (
//     <div>
//       <Helmet>
//         <script>
//           {`
//             window.gtranslateSettings = {
//               "default_language": "en",
//               "languages": ["en", "it", "hi", "tr", "af", "da", "ar", "pt", "zu", "zh-CN", "tl", "nl", "ha", "sv", "ja", "de"],
//               "wrapper_selector": ".gtranslate_wrapper"
//             };
//           `}
//         </script>
//       </Helmet>

//       <div className="gtranslate_wrapper"></div>
//     </div>
//   );
// };

// export default GTranslateWidget;


const GTranslateWidget = ({children}) => {
  const markup = renderToStaticMarkup(
    <html>
      <head />
      <body>{children}</body>
    </html>
  );
  return (
    <>
        {formatHTML(markup)}
    </>
  );
}

export default GTranslateWidget;

